import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-outline-button',
  imports: [MatButtonModule],
  templateUrl: './outline-button.html',
  styleUrl: './outline-button.scss',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class OutlineButton {
  @Input() text: string = 'Cancel';
  @Output() eventTriggered: EventEmitter<void> = new EventEmitter();

  triggerEvent() {
    this.eventTriggered.emit();
  }
}
